module.exports = __webpack_public_path__ + "img/HealthHelp_MentalHealthCheck.80971aa0.svg";